// import React, { useState, useEffect, useMemo } from "react";
// import { Container, Row, Col, Card, CardBody, Table, Modal } from "reactstrap";
// import {
//   useTable,
//   useSortBy,
//   usePagination,
//   useGlobalFilter,
// } from "react-table";
// import Select from "react-select";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Loader from "pages/Separate/Loader";
// import Breadcrumbs from "components/Common/Breadcrumb";
// import NewPagination from "components/Common/Newpagination";
// import configure from "configure";
// import { RfpPermissionsColumns } from "utils/columns/Roles/RolesColumns";
// import rfpImg from "assets/images/role-3.avif"; // reuse same image as Roles
// import { useNavigate } from "react-router-dom";

// // ─────────────────────────────────────────────────────────────────────────────
// // Constants
// // ─────────────────────────────────────────────────────────────────────────────

// const STEPS = [
//   { key: "step1", label: "Services", cols: ["view", "edit", "add", "approve"] },
//   { key: "step2", label: "Features", cols: ["view", "edit", "add", "approve"] },
//   { key: "step3", label: "Timing", cols: ["view", "edit", "add", "approve"] },
//   { key: "step4", label: "Costing", cols: ["view", "edit", "add", "approve"] },
//   { key: "step5", label: "Overview", cols: ["view", "approve"] },
// ];

// const EMPTY_PERMS = {
//   step1: { view: 0, edit: 0, add: 0, approve: 0 },
//   step2: { view: 0, edit: 0, add: 0, approve: 0 },
//   step3: { view: 0, edit: 0, add: 0, approve: 0 },
//   step4: { view: 0, edit: 0, add: 0, approve: 0 },
//   step5: { view: 0, approve: 0 },
// };

// const permsToStrings = (perms) => ({
//   step1: `${perms.step1.view},${perms.step1.edit},${perms.step1.add},${perms.step1.approve}`,
//   step2: `${perms.step2.view},${perms.step2.edit},${perms.step2.add},${perms.step2.approve}`,
//   step3: `${perms.step3.view},${perms.step3.edit},${perms.step3.add},${perms.step3.approve}`,
//   step4: `${perms.step4.view},${perms.step4.edit},${perms.step4.add},${perms.step4.approve}`,
//   step5: `${perms.step5.view},${perms.step5.approve}`,
// });

// // ─────────────────────────────────────────────────────────────────────────────
// // Table component (mirrors Roles TableContainer exactly)
// // ─────────────────────────────────────────────────────────────────────────────
// const UserAvatar = ({ userId, allUsers, getUserName }) => {
//   const u = allUsers.find((u) => String(u.id) === String(userId));
//   const img = u?.image || u?.avatar || u?.profile_image;
//   const initials = getUserName(userId)?.[0]?.toUpperCase();
//   const fallbackStyle = {
//     width: 20,
//     height: 20,
//     borderRadius: "50%",
//     background: "#752a97",
//     color: "#fff",
//     fontSize: "9px",
//     fontWeight: 700,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   };
//   return img ? (
//     <img
//       src={`${configure.imgUrl}${img}`}
//       alt={getUserName(userId)}
//       style={{
//         width: 20,
//         height: 20,
//         borderRadius: "50%",
//         objectFit: "cover",
//         flexShrink: 0,
//       }}
//       onError={(e) => {
//         e.target.replaceWith(
//           Object.assign(document.createElement("div"), {
//             textContent: initials,
//             style: Object.entries(fallbackStyle)
//               .map(([k, v]) => `${k}:${v}`)
//               .join(";"),
//           }),
//         );
//       }}
//     />
//   ) : (
//     <div style={fallbackStyle}>{initials}</div>
//   );
// };
// function TableContainer({
//   columns,
//   data,
//   // onAdd,
//   setLoading,
//   getUserName,
//   onLevelChange,
//   allUsers,
// }) {
//   const [fixedHeader, setFixedHeader] = useState(false);
//   const [fixedContent, setFixedContent] = useState(false);

//   document.addEventListener("scroll", () => {
//     const threshold = window.innerHeight * 0.25;
//     setFixedContent(window.scrollY > threshold);
//     setFixedHeader(window.scrollY > 165);
//   });

//   // Inside TableContainer, add:
//   const [editingLevel, setEditingLevel] = useState(null);
//   const [pendingSelections, setPendingSelections] = useState({});

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//       initialState: { sortBy: [{ id: "user_id", desc: true }] },
//     },
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//   );

//   const navigate = useNavigate();

//   const { pageIndex, pageSize, globalFilter } = state;
//   useEffect(() => setPageSize(50), []);

//   console.log("allUsers", allUsers);

//   return (
//     <div>
//       {/* Fixed scroll buttons */}
//       <div
//         className={`flex-column fixed-buttons pt-2 ${
//           fixedContent ? "d-flex" : "d-none"
//         }`}
//       >
//         {/* <button onClick={onAdd} className="btn btn-save fix-btn btn-label pe-0">
//           <i className="fas fa-plus me-2 icon-size label-icon"></i>
//           <span>Add</span>
//         </button> */}
//       </div>

//       {/* Top bar — page size + search + Add button */}
//       <Row className="mb-2">
//         <Col>
//           <select
//             className="form-select"
//             style={{ width: "100px" }}
//             value={pageSize}
//             onChange={(e) => setPageSize(e.target.value)}
//           >
//             {[10, 20, 30, 40, 50].map((ps) => (
//               <option key={ps} value={ps}>
//                 Show {ps}
//               </option>
//             ))}
//           </select>
//         </Col>
//         <Col className="d-flex justify-content-end">
//           <div className="me-4">
//             <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
//               <div className="position-relative">
//                 <label htmlFor="rfp-perm-search" className="search-label">
//                   <span className="sr-only">Search this table</span>
//                   <input
//                     id="rfp-perm-search"
//                     type="text"
//                     className="form-control rounded h-100"
//                     placeholder="Search..."
//                     value={globalFilter || ""}
//                     onChange={(e) => setGlobalFilter(e.target.value)}
//                   />
//                 </label>
//                 <i className="bx bx-search-alt search-icon"></i>
//               </div>
//             </div>
//           </div>
//           <div>
//             {/* <button onClick={onAdd} className="btn btn-save btn-label">
//               <i className="fas fa-plus me-2 icon-size label-icon"></i>
//               Add Permission
//             </button> */}
//             <button
//               onClick={() => navigate(-1)}
//               className="btn btn-red btn-label"
//             >
//               <i className="dripicons-cross me-2 icon-center label-icon"></i>
//               <span>Cancel</span>
//             </button>
//           </div>
//         </Col>
//       </Row>

//       {/* Table + side image — same 4/8 split as Roles */}
//       <div className="row">
//         <div className="col-md-4 d-flex justify-content-center">
//           <div className={fixedHeader ? "rolesIndexImg" : ""}>
//             <img src={rfpImg} alt="rfpImg" className="w-100" />
//           </div>
//         </div>
//         <div className="col-md-8 pt-4">
//           <div className="mt-2">
//             {[
//               {
//                 id: "timing",
//                 label: "Level 1 (Timing) ",
//                 color: "#f59e0b",
//                 lightColor: "#fffbeb",
//                 borderColor: "#fde68a",
//               },
//               {
//                 id: "costing",
//                 label: "Level 2 (Costing)",
//                 color: "#752a97",
//                 lightColor: "#f0e6f6",
//                 borderColor: "#d8bfe8",
//               },
//               {
//                 id: "final",
//                 label: "Final Approval Level",
//                 color: "#16a34a",
//                 lightColor: "#f0fdf4",
//                 borderColor: "#bbf7d0",
//               },
//             ].map((level) => {
//               // const levelRows = data.filter((r) => r.level === level.id);
//               const levelRows = data.filter((r) => {
//                 const levels = (r.level || "")
//                   .split(",")
//                   .map((l) => l.trim())
//                   .filter(Boolean);
//                 return levels.includes(level.id);
//               });
//               const isEditing = editingLevel === level.id;

//               return (
//                 <div
//                   key={level.id}
//                   className="card mb-3"
//                   style={{
//                     border: "1px solid #e0e0e0",
//                     borderRadius: "8px",
//                     boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
//                   }}
//                 >
//                   <div className="d-flex align-items-center p-3 gap-3">
//                     {/* Level label */}
//                     <div style={{ minWidth: 180, flexShrink: 0 }}>
//                       <span
//                         className="fw-semibold"
//                         style={{ fontSize: "13px", color: "#330148" }}
//                       >
//                         {level.label}
//                       </span>
//                       <div style={{ fontSize: "11px", color: "#aaa" }}>
//                         {levelRows.length} user
//                         {levelRows.length !== 1 ? "s" : ""}
//                       </div>
//                     </div>

//                     {/* Toggle between pill display and Select */}
//                     <div style={{ flex: 1 }}>
//                       {isEditing ? (
//                         <Select
//                           isMulti
//                           placeholder="Assign users..."
//                           options={allUsers.map((u) => ({
//                             value: String(u.id),
//                             label: u.name,
//                           }))}
//                           value={
//                             pendingSelections[level.id] ??
//                             levelRows.map((r) => ({
//                               value: String(r.user_id),
//                               label: getUserName(r.user_id),
//                             }))
//                           }
//                           onChange={(selected) =>
//                             setPendingSelections((prev) => ({
//                               ...prev,
//                               [level.id]: selected || [],
//                             }))
//                           }
//                           classNamePrefix="select"
//                           menuPortalTarget={document.body}
//                           menuPosition="fixed"
//                         />
//                       ) : (
//                         <div
//                           className="d-flex align-items-center flex-wrap gap-2"
//                           style={{
//                             minHeight: 38,
//                             background: "#fafafa",
//                             border: "1px solid #e0e0e0",
//                             borderRadius: "6px",
//                             padding: "6px 10px",
//                           }}
//                         >
//                           {levelRows.length === 0 ? (
//                             <span style={{ color: "#ccc", fontSize: "12px" }}>
//                               No users assigned
//                             </span>
//                           ) : (
//                             levelRows.map((row) => (
//                               <div
//                                 key={row.user_id}
//                                 className="d-flex align-items-center gap-1"
//                                 style={{
//                                   background: "#fff",
//                                   border: "1px solid #e5e7eb",
//                                   borderRadius: "20px",
//                                   padding: "2px 8px 2px 3px",
//                                 }}
//                               >
//                                 {/* <div style={{
//                   width: 20, height: 20, borderRadius: "50%",
//                   background: "#752a97", color: "#fff",
//                   fontSize: "9px", fontWeight: 700,
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                   flexShrink: 0,
//                 }}>
//                   {getUserName(row.user_id)?.[0]?.toUpperCase()}
//                 </div> */}
//                                 {(() => {
//                                   const u = allUsers?.find(
//                                     (u) => String(u.id) === String(row.user_id),
//                                   );
//                                   return u?.avatar ? (
//                                     <img
//                                       src={`${configure.apiUrl}${u.avatar}`}
//                                       alt={u.name}
//                                       style={{
//                                         width: 20,
//                                         height: 20,
//                                         borderRadius: "50%",
//                                         objectFit: "cover",
//                                         flexShrink: 0,
//                                       }}
//                                     />
//                                   ) : (
//                                     <div
//                                       style={{
//                                         width: 20,
//                                         height: 20,
//                                         borderRadius: "50%",
//                                         background: "#752a97",
//                                         color: "#fff",
//                                         fontSize: "9px",
//                                         fontWeight: 700,
//                                         display: "flex",
//                                         alignItems: "center",
//                                         justifyContent: "center",
//                                         flexShrink: 0,
//                                       }}
//                                     >
//                                       {getUserName(
//                                         row.user_id,
//                                       )?.[0]?.toUpperCase()}
//                                     </div>
//                                   );
//                                 })()}
//                                 <span
//                                   style={{
//                                     fontSize: "12px",
//                                     color: "#333",
//                                     fontWeight: 500,
//                                   }}
//                                 >
//                                   {getUserName(row.user_id)}
//                                 </span>
//                               </div>
//                             ))
//                           )}
//                         </div>
//                       )}
//                     </div>

//                     {/* Buttons */}
//                     <div className="d-flex gap-2" style={{ flexShrink: 0 }}>
//                       {isEditing && (
//                         <button
//                           className="btn btn-save btn-sm btn-label"
//                           // onClick={() => setEditingLevel(null)}
//                           // onClick={async () => {
//                           //   const selected = pendingSelections[level.id];
//                           //   if (selected !== undefined) {
//                           //     await onLevelChange(
//                           //       level.id,
//                           //       selected.map((s) => ({
//                           //         ...s,
//                           //         value: Number(s.value),
//                           //       })),
//                           //     );
//                           //     setPendingSelections((prev) => {
//                           //       const n = { ...prev };
//                           //       delete n[level.id];
//                           //       return n;
//                           //     });
//                           //   }
//                           //   setEditingLevel(null);
//                           // }}
//                           // REPLACE WITH:
//                           onClick={async () => {
//                             const selected = pendingSelections[level.id];
//                             if (selected !== undefined) {
//                               setLoading(true); // show loader while saving
//                               try {
//                                 await onLevelChange(
//                                   level.id,
//                                   selected.map((s) => ({
//                                     ...s,
//                                     value: Number(s.value),
//                                   })),
//                                 );
//                               } finally {
//                                 setLoading(false);
//                               }
//                               setPendingSelections((prev) => {
//                                 const n = { ...prev };
//                                 delete n[level.id];
//                                 return n;
//                               });
//                             }
//                             setEditingLevel(null);
//                           }}
//                         >
//                           <i className="fas fa-save me-1 label-icon"></i>Save
//                         </button>
//                       )}
//                       <button
//                         className="btn btn-sm btn-outline-secondary"
//                         style={{ fontSize: "12px" }}
//                         // onClick={() => setEditingLevel(isEditing ? null : level.id)}
//                         onClick={() => {
//                           setPendingSelections((prev) => {
//                             const n = { ...prev };
//                             delete n[level.id];
//                             return n;
//                           });
//                           setEditingLevel(isEditing ? null : level.id);
//                         }}
//                       >
//                         {isEditing ? (
//                           <>
//                             <i className="dripicons-cross me-1 icon-center"></i>
//                             Cancel
//                           </>
//                         ) : (
//                           <>
//                             <i className="fas fa-pencil-alt me-1"></i>Edit
//                           </>
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {/* Pagination */}
//       <Row className="justify-content-md-end justify-content-center align-items-center">
//         <NewPagination
//           gotoPage={gotoPage}
//           canPreviousPage={canPreviousPage}
//           canNextPage={canNextPage}
//           pageIndex={pageIndex}
//           pageOptions={pageOptions}
//           pageSize={pageSize}
//           page={page}
//           data={data}
//         />
//       </Row>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // Main page
// // ─────────────────────────────────────────────────────────────────────────────

// const RfpPermissions = () => {
//   document.title = "RFP Permissions | Zithas Technologies";

//   const [isLoading, setLoading] = useState(false);
//   const [allUsers, setAllUsers] = useState([]);
//   const [rows, setRows] = useState([]);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [isAddMode, setIsAddMode] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [editPerms, setEditPerms] = useState(null);

//   // ── Fetch users ──────────────────────────────────────────────
//   useEffect(() => {
//     axios
//       .get(`${configure.apiUrl}/staff`, {
//         headers: { Accept: "application/json" },
//       })
//       .then((res) => {
//         if (res.data.success) setAllUsers(res.data.data || []);
//       })
//       .catch(console.error);
//   }, []);

//   // ── Fetch permissions ────────────────────────────────────────
//   const fetchAll = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${configure.nodeApi}/rfp_permissions_all`, {
//         headers: { Accept: "application/json" },
//       });
//       if (res.data.success) setRows(res.data.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAll();
//   }, []);

//   // ── Helpers ──────────────────────────────────────────────────
//   const getUserName = (userId) => {
//     const u = allUsers.find((u) => u.id == userId);
//     return u ? u.name : `User #${userId}`;
//   };

//   const usersWithPerms = new Set(rows.map((r) => Number(r.user_id)));
//   const unassignedOptions = allUsers
//     .filter((u) => !usersWithPerms.has(u.id))
//     .map((u) => ({ value: u.id, label: u.name }));

//   // ── Toggle ───────────────────────────────────────────────────
//   const togglePerm = (stepKey, col) =>
//     setEditPerms((prev) => ({
//       ...prev,
//       [stepKey]: { ...prev[stepKey], [col]: prev[stepKey][col] === 1 ? 0 : 1 },
//     }));

//   const setAllForStep = (stepKey, value) => {
//     const step = STEPS.find((s) => s.key === stepKey);
//     const updated = {};
//     step.cols.forEach((col) => {
//       updated[col] = value;
//     });
//     setEditPerms((prev) => ({ ...prev, [stepKey]: updated }));
//   };

//   const isAllSet = (stepKey) => {
//     const step = STEPS.find((s) => s.key === stepKey);
//     return step.cols.every((col) => editPerms?.[stepKey]?.[col] === 1);
//   };

//   // ── Open modals ──────────────────────────────────────────────
//   // const openAdd = () => {
//   //   setIsAddMode(true);
//   //   setSelectedUser(null);
//   //   setEditPerms(JSON.parse(JSON.stringify(EMPTY_PERMS)));
//   //   setModalOpen(true);
//   // };

//   const openEdit = (userId) => {
//     const existing = rows.find((r) => r.user_id == userId);
//     setIsAddMode(false);
//     setSelectedUser(userId);
//     setEditPerms(
//       existing
//         ? JSON.parse(JSON.stringify(existing.parsed))
//         : JSON.parse(JSON.stringify(EMPTY_PERMS)),
//     );
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setSelectedUser(null);
//     setEditPerms(null);
//   };

//   // ── Save ─────────────────────────────────────────────────────
//   const handleSave = async () => {
//     const userId = isAddMode ? selectedUser?.value : selectedUser;
//     if (!userId)
//       return Swal.fire({ icon: "warning", text: "Please select a user" });
//     setLoading(true);
//     try {
//       const res = await axios.post(
//         `${configure.nodeApi}/save_rfp_permissions`,
//         { user_id: userId, ...permsToStrings(editPerms) },
//         { headers: { "Content-Type": "application/json" } },
//       );
//       if (res.data.success) {
//         await fetchAll();
//         closeModal();
//         Swal.fire({
//           icon: "success",
//           text: "Permissions saved!",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       } else {
//         Swal.fire({ icon: "error", text: res.data.message });
//       }
//     } catch {
//       Swal.fire({ icon: "error", text: "Failed to save permissions" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Delete ───────────────────────────────────────────────────
//   const handleDelete = (userId) => {
//     Swal.fire({
//       title: "Remove RFP permissions?",
//       text: `All RFP permissions for ${getUserName(userId)} will be removed.`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, remove",
//       confirmButtonColor: "#d33",
//     }).then(async (result) => {
//       if (!result.isConfirmed) return;
//       setLoading(true);
//       try {
//         await axios.post(
//           `${configure.nodeApi}/save_rfp_permissions`,
//           {
//             user_id: userId,
//             step1: "0,0,0,0",
//             step2: "0,0,0,0",
//             step3: "0,0,0,0",
//             step4: "0,0,0,0",
//             step5: "0,0",
//           },
//           { headers: { "Content-Type": "application/json" } },
//         );
//         await fetchAll();
//         Swal.fire({
//           icon: "success",
//           text: "Permissions removed!",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       } catch {
//         Swal.fire({ icon: "error", text: "Failed to remove permissions" });
//       } finally {
//         setLoading(false);
//       }
//     });
//   };

//   // const handleLevelChange = async (levelId, selectedUsers) => {
//   //   // Map level to the perms preset for that level
//   //   const LEVEL_PERMS = {
//   //     timing: {
//   //       step1: "1,1,1,1",
//   //       step2: "1,1,1,1",
//   //       step3: "1,1,1,0",
//   //       step4: "1,1,0,0",
//   //       step5: "1,0",
//   //     },
//   //     costing: {
//   //       step1: "1,1,1,0",
//   //       step2: "1,1,1,0",
//   //       step3: "1,1,1,1",
//   //       step4: "1,1,1,0",
//   //       step5: "1,0",
//   //     },
//   //     final: {
//   //       step1: "1,1,1,0",
//   //       step2: "1,1,1,0",
//   //       step3: "1,1,1,1",
//   //       step4: "1,1,1,1",
//   //       step5: "1,1",
//   //     },
//   //   };

//   //   const currentForLevel = rows.filter((r) => r.level === levelId);
//   //   const newIds = new Set(selectedUsers.map((u) => Number(u.value)));
//   //   const oldIds = new Set(currentForLevel.map((r) => Number(r.user_id)));

//   //   // for (const u of selectedUsers) {
//   //   //   if (!oldIds.has(Number(u.value))) {
//   //   //     await axios.post(
//   //   //       `${configure.nodeApi}/save_rfp_permissions`,
//   //   //       { user_id: u.value, level: levelId, ...LEVEL_PERMS[levelId] },
//   //   //       { headers: { "Content-Type": "application/json" } },
//   //   //     );
//   //   //   }
//   //   // }
//   //   // // Remove deselected users
//   //   // for (const r of currentForLevel) {
//   //   //   if (!newIds.has(Number(r.user_id))) {
//   //   //     await axios.post(
//   //   //       `${configure.nodeApi}/save_rfp_permissions`,
//   //   //       {
//   //   //         user_id: r.user_id,
//   //   //         step1: "0,0,0,0",
//   //   //         step2: "0,0,0,0",
//   //   //         step3: "0,0,0,0",
//   //   //         step4: "0,0,0,0",
//   //   //         step5: "0,0",
//   //   //       },
//   //   //       { headers: { "Content-Type": "application/json" } },
//   //   //     );
//   //   //   }
//   //   // }

//   //   await Promise.all([
//   //     ...selectedUsers
//   //       .filter((u) => !oldIds.has(Number(u.value)))
//   //       .map((u) =>
//   //         axios.post(
//   //           `${configure.nodeApi}/save_rfp_permissions`,
//   //           { user_id: u.value, level: levelId, ...LEVEL_PERMS[levelId] },
//   //           { headers: { "Content-Type": "application/json" } },
//   //         ),
//   //       ),
//   //     ...currentForLevel
//   //       .filter((r) => !newIds.has(Number(r.user_id)))
//   //       .map((r) =>
//   //         axios.post(
//   //           `${configure.nodeApi}/save_rfp_permissions`,
//   //           {
//   //             user_id: r.user_id,
//   //             level: null,
//   //             step1: "1,1,1,0",
//   //             step2: "1,1,1,0",
//   //             step3: "1,1,0,0",
//   //             step4: "1,1,0,0",
//   //             step5: "1,0",
//   //           },
//   //           { headers: { "Content-Type": "application/json" } },
//   //         ),
//   //       ),
//   //   ]);

//   //   await fetchAll();
//   // };

//   // Helper — merges perms for multiple levels, taking highest value per bit
//   const mergePermsForLevels = (levels, LEVEL_PERMS) => {
//     const parse = (str, len) => (str || "0".repeat(len)).split(",").map(Number);

//     const merged = {
//       step1: [0, 0, 0, 0],
//       step2: [0, 0, 0, 0],
//       step3: [0, 0, 0, 0],
//       step4: [0, 0, 0, 0],
//       step5: [0, 0],
//     };

//     for (const level of levels) {
//       const p = LEVEL_PERMS[level];
//       if (!p) continue;
//       merged.step1 = merged.step1.map((v, i) =>
//         Math.max(v, parse(p.step1, 4)[i]),
//       );
//       merged.step2 = merged.step2.map((v, i) =>
//         Math.max(v, parse(p.step2, 4)[i]),
//       );
//       merged.step3 = merged.step3.map((v, i) =>
//         Math.max(v, parse(p.step3, 4)[i]),
//       );
//       merged.step4 = merged.step4.map((v, i) =>
//         Math.max(v, parse(p.step4, 4)[i]),
//       );
//       merged.step5 = merged.step5.map((v, i) =>
//         Math.max(v, parse(p.step5, 2)[i]),
//       );
//     }

//     return {
//       step1: merged.step1.join(","),
//       step2: merged.step2.join(","),
//       step3: merged.step3.join(","),
//       step4: merged.step4.join(","),
//       step5: merged.step5.join(","),
//     };
//   };

//   const handleLevelChange = async (levelId, selectedUsers) => {
//     const LEVEL_PERMS = {
//       timing: {
//         step1: "1,1,1,1",
//         step2: "1,1,1,1",
//         step3: "1,1,1,0",
//         step4: "1,1,0,0",
//         step5: "1,0",
//       },
//       costing: {
//         step1: "1,1,1,0",
//         step2: "1,1,1,0",
//         step3: "1,1,1,1",
//         step4: "1,1,1,0",
//         step5: "1,0",
//       },
//       final: {
//         step1: "1,1,1,0",
//         step2: "1,1,1,0",
//         step3: "1,1,1,1",
//         step4: "1,1,1,1",
//         step5: "1,1",
//       },
//     };

//     // Users currently in THIS level
//     const currentForLevel = rows.filter((r) => {
//       const levels = (r.level || "")
//         .split(",")
//         .map((l) => l.trim())
//         .filter(Boolean);
//       return levels.includes(levelId);
//     });

//     const newIds = new Set(selectedUsers.map((u) => Number(u.value)));
//     const oldIds = new Set(currentForLevel.map((r) => Number(r.user_id)));

//     // Users being ADDED to this level
//     const toAdd = selectedUsers.filter((u) => !oldIds.has(Number(u.value)));

//     // Users being REMOVED from this level
//     const toRemove = currentForLevel.filter(
//       (r) => !newIds.has(Number(r.user_id)),
//     );

//     await Promise.all([
//       // ── ADD: merge this new level into their existing levels ──
//       ...toAdd.map((u) => {
//         const existing = rows.find(
//           (r) => Number(r.user_id) === Number(u.value),
//         );
//         const existingLevels = (existing?.level || "")
//           .split(",")
//           .map((l) => l.trim())
//           .filter(Boolean);

//         // Add this level if not already there
//         if (!existingLevels.includes(levelId)) existingLevels.push(levelId);

//         const newLevel = existingLevels.join(",");
//         const newPerms = mergePermsForLevels(existingLevels, LEVEL_PERMS);

//         return axios.post(
//           `${configure.nodeApi}/save_rfp_permissions`,
//           { user_id: u.value, level: newLevel, ...newPerms },
//           { headers: { "Content-Type": "application/json" } },
//         );
//       }),

//       // ── REMOVE: strip this level, keep remaining levels ──
//       ...toRemove.map((r) => {
//         const remainingLevels = (r.level || "")
//           .split(",")
//           .map((l) => l.trim())
//           .filter(Boolean)
//           .filter((l) => l !== levelId); // remove only this level

//         const newLevel = remainingLevels.join(",") || null;
//         const newPerms =
//           remainingLevels.length > 0
//             ? mergePermsForLevels(remainingLevels, LEVEL_PERMS)
//             : {
//                 step1: "1,1,1,0",
//                 step2: "1,1,1,0",
//                 step3: "1,1,0,0",
//                 step4: "1,1,0,0",
//                 step5: "1,0",
//               };

//         return axios.post(
//           `${configure.nodeApi}/save_rfp_permissions`,
//           { user_id: r.user_id, level: newLevel, ...newPerms },
//           { headers: { "Content-Type": "application/json" } },
//         );
//       }),
//     ]);

//     await fetchAll();
//   };

//   // ── Columns (memoized) ───────────────────────────────────────
//   const columns = useMemo(
//     () => RfpPermissionsColumns(openEdit, handleDelete, getUserName),
//     [rows, allUsers],
//   );

//   console.log("unassignedOptions", unassignedOptions);
//   // ─────────────────────────────────────────────────────────────

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="page-content">
//         <Container fluid>
//           <Breadcrumbs title="Dashboard" breadcrumbItem="RFP Permissions" />
//           <Row>
//             <Col lg={12} className="p-0">
//               <Card>
//                 <CardBody>
//                   <div className="responsive-table">
//                     <TableContainer
//                       columns={columns}
//                       data={rows}
//                       // onAdd={openAdd}
//                       setLoading={setLoading}
//                       getUserName={getUserName}
//                       onLevelChange={handleLevelChange}
//                       allUsers={allUsers}
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       {/* ── Add / Edit Modal ── */}
//       <Modal isOpen={modalOpen} toggle={closeModal} centered size="lg">
//         <div className="modal-header">
//           <h5 className="modal-title mt-0">
//             {isAddMode
//               ? "Add RFP Permissions"
//               : `Edit — ${getUserName(selectedUser)}`}
//           </h5>
//           <button
//             type="button"
//             onClick={closeModal}
//             className="btn-modal-close"
//           >
//             <span className="btn-modal-span">&times;</span>
//           </button>
//         </div>

//         <div className="modal-body">
//           {/* User dropdown — Add mode only */}
//           {isAddMode && (
//             <div className="mb-4 col-md-4">
//               <label className="form-label fw-semibold">
//                 Select User <span className="text-danger">*</span>
//               </label>
//               <Select
//                 placeholder="select user"
//                 options={unassignedOptions}
//                 value={selectedUser}
//                 onChange={(opt) => setSelectedUser(opt)}
//                 classNamePrefix="select"
//                 noOptionsMessage={() => "All users already configured"}
//               />
//             </div>
//           )}

//           {editPerms && (
//             <>
//               {/* Quick presets */}
//               <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
//                 <span
//                   className="text-muted fw-semibold"
//                   style={{ fontSize: "12px" }}
//                 >
//                   Quick set:
//                 </span>
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={() => {
//                     const full = JSON.parse(JSON.stringify(EMPTY_PERMS));
//                     STEPS.forEach((s) =>
//                       s.cols.forEach((c) => {
//                         full[s.key][c] = 1;
//                       }),
//                     );
//                     setEditPerms(full);
//                   }}
//                 >
//                   ✓ Full Access
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={() =>
//                     setEditPerms(JSON.parse(JSON.stringify(EMPTY_PERMS)))
//                   }
//                 >
//                   ✕ No Access
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-outline-secondary"
//                   onClick={() => {
//                     const v = JSON.parse(JSON.stringify(EMPTY_PERMS));
//                     STEPS.forEach((s) => {
//                       v[s.key].view = 1;
//                     });
//                     setEditPerms(v);
//                   }}
//                 >
//                   👁 View Only
//                 </button>
//               </div>

//               {/* Permissions table */}
//               <div className="table-responsive">
//                 <Table
//                   className="table table-bordered mb-0"
//                   style={{ fontSize: "13px" }}
//                 >
//                   <thead className="table-light">
//                     <tr>
//                       <th style={{ width: "160px" }}>Step</th>
//                       <th className="text-center">View</th>
//                       <th className="text-center">Edit</th>
//                       <th className="text-center">Add</th>
//                       <th className="text-center">Approve</th>
//                       <th className="text-center" style={{ width: "70px" }}>
//                         All
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {STEPS.map((step) => (
//                       <tr key={step.key}>
//                         <td className="fw-semibold align-middle">
//                           {step.label}
//                         </td>
//                         {["view", "edit", "add", "approve"].map((col) => {
//                           const applicable = step.cols.includes(col);
//                           const checked = applicable
//                             ? editPerms[step.key]?.[col] === 1
//                             : false;
//                           return (
//                             <td key={col} className="text-center align-middle">
//                               {applicable ? (
//                                 <div className="form-switch form-switch-md d-flex justify-content-center">
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input"
//                                     checked={checked}
//                                     onChange={() => togglePerm(step.key, col)}
//                                     style={{ cursor: "pointer" }}
//                                   />
//                                 </div>
//                               ) : (
//                                 <span className="text-muted">—</span>
//                               )}
//                             </td>
//                           );
//                         })}
//                         <td className="text-center align-middle">
//                           <button
//                             type="button"
//                             className={`btn btn-sm ${
//                               isAllSet(step.key)
//                                 ? "btn-outline-danger"
//                                 : "btn-outline-secondary"
//                             }`}
//                             style={{ fontSize: "11px", padding: "2px 8px" }}
//                             onClick={() =>
//                               setAllForStep(
//                                 step.key,
//                                 isAllSet(step.key) ? 0 : 1,
//                               )
//                             }
//                           >
//                             {isAllSet(step.key) ? "Clear" : "All"}
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//             </>
//           )}
//         </div>

//         <div className="modal-footer">
//           <button className="btn btn-save btn-label" onClick={handleSave}>
//             <i className="fas fa-save me-2 label-icon"></i>
//             Save
//           </button>
//           <button className="btn btn-red btn-label ms-2" onClick={closeModal}>
//             <i className="dripicons-cross me-2 icon-center label-icon"></i>
//             Cancel
//           </button>
//         </div>
//       </Modal>
//     </React.Fragment>
//   );
// };

// export default RfpPermissions;



import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Card, CardBody, Table, Modal } from "reactstrap";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "pages/Separate/Loader";
import Breadcrumbs from "components/Common/Breadcrumb";
import NewPagination from "components/Common/Newpagination";
import configure from "configure";
import { RfpPermissionsColumns } from "utils/columns/Roles/RolesColumns";
import rfpImg from "assets/images/role-3.avif"; // reuse same image as Roles
import { useNavigate } from "react-router-dom";

// ─────────────────────────────────────────────────────────────────────────────
// Constants
// ─────────────────────────────────────────────────────────────────────────────

const STEPS = [
  { key: "step1", label: "Services", cols: ["view", "edit", "add", "approve"] },
  { key: "step2", label: "Features", cols: ["view", "edit", "add", "approve"] },
  { key: "step3", label: "Timing", cols: ["view", "edit", "add", "approve"] },
  { key: "step4", label: "Costing", cols: ["view", "edit", "add", "approve"] },
  { key: "step5", label: "Overview", cols: ["view", "approve"] },
];

const EMPTY_PERMS = {
  step1: { view: 0, edit: 0, add: 0, approve: 0 },
  step2: { view: 0, edit: 0, add: 0, approve: 0 },
  step3: { view: 0, edit: 0, add: 0, approve: 0 },
  step4: { view: 0, edit: 0, add: 0, approve: 0 },
  step5: { view: 0, approve: 0 },
};

const permsToStrings = (perms) => ({
  step1: `${perms.step1.view},${perms.step1.edit},${perms.step1.add},${perms.step1.approve}`,
  step2: `${perms.step2.view},${perms.step2.edit},${perms.step2.add},${perms.step2.approve}`,
  step3: `${perms.step3.view},${perms.step3.edit},${perms.step3.add},${perms.step3.approve}`,
  step4: `${perms.step4.view},${perms.step4.edit},${perms.step4.add},${perms.step4.approve}`,
  step5: `${perms.step5.view},${perms.step5.approve}`,
});

// ─────────────────────────────────────────────────────────────────────────────
// Table component (mirrors Roles TableContainer exactly)
// ─────────────────────────────────────────────────────────────────────────────
const UserAvatar = ({ userId, allUsers, getUserName }) => {
  const u = allUsers.find((u) => String(u.id) === String(userId));
  const img = u?.image || u?.avatar || u?.profile_image;
  const initials = getUserName(userId)?.[0]?.toUpperCase();
  const fallbackStyle = {
    width: 20,
    height: 20,
    borderRadius: "50%",
    background: "#752a97",
    color: "#fff",
    fontSize: "9px",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };
  return img ? (
    <img
      src={`${configure.imgUrl}${img}`}
      alt={getUserName(userId)}
      style={{
        width: 20,
        height: 20,
        borderRadius: "50%",
        objectFit: "cover",
        flexShrink: 0,
      }}
      onError={(e) => {
        e.target.replaceWith(
          Object.assign(document.createElement("div"), {
            textContent: initials,
            style: Object.entries(fallbackStyle)
              .map(([k, v]) => `${k}:${v}`)
              .join(";"),
          }),
        );
      }}
    />
  ) : (
    <div style={fallbackStyle}>{initials}</div>
  );
};
function TableContainer({
  columns,
  data,
  // onAdd,
  setLoading,
  getUserName,
  onLevelChange,
  allUsers,
}) {
  const [fixedHeader, setFixedHeader] = useState(false);
  const [fixedContent, setFixedContent] = useState(false);

  document.addEventListener("scroll", () => {
    const threshold = window.innerHeight * 0.25;
    setFixedContent(window.scrollY > threshold);
    setFixedHeader(window.scrollY > 165);
  });

  // Inside TableContainer, add:
  const [editingLevel, setEditingLevel] = useState(null);
  const [pendingSelections, setPendingSelections] = useState({});

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: { sortBy: [{ id: "user_id", desc: true }] },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const navigate = useNavigate();

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);

  console.log("allUsers", allUsers);

  return (
    <div>
      {/* Fixed scroll buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        {/* <button onClick={onAdd} className="btn btn-save fix-btn btn-label pe-0">
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Add</span>
        </button> */}
      </div>

      {/* Top bar — page size + search + Add button */}
      <Row className="mb-2">
        <Col>
          <select
            className="form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map((ps) => (
              <option key={ps} value={ps}>
                Show {ps}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="rfp-perm-search" className="search-label">
                  <span className="sr-only">Search this table</span>
                  <input
                    id="rfp-perm-search"
                    type="text"
                    className="form-control rounded h-100"
                    placeholder="Search..."
                    value={globalFilter || ""}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div>
            {/* <button onClick={onAdd} className="btn btn-save btn-label">
              <i className="fas fa-plus me-2 icon-size label-icon"></i>
              Add Permission
            </button> */}
            <button
              onClick={() => navigate(-1)}
              className="btn btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              <span>Cancel</span>
            </button>
          </div>
        </Col>
      </Row>

      {/* Table + side image — same 4/8 split as Roles */}
      <div className="row">
        <div className="col-md-4 d-flex justify-content-center">
          <div className={fixedHeader ? "rolesIndexImg" : ""}>
            <img src={rfpImg} alt="rfpImg" className="w-100" />
          </div>
        </div>
        <div className="col-md-8 pt-4">
          <div className="mt-2">
            {[
              {
                id: "timing",
                label: "Level 1 (Timing) ",
                color: "#f59e0b",
                lightColor: "#fffbeb",
                borderColor: "#fde68a",
              },
              {
                id: "costing",
                label: "Level 2 (Costing)",
                color: "#752a97",
                lightColor: "#f0e6f6",
                borderColor: "#d8bfe8",
              },
              {
                id: "final",
                label: "Final Approval Level",
                color: "#16a34a",
                lightColor: "#f0fdf4",
                borderColor: "#bbf7d0",
              },
            ].map((level) => {
              // const levelRows = data.filter((r) => r.level === level.id);
              const levelRows = data.filter((r) => {
                const levels = (r.level || "")
                  .split(",")
                  .map((l) => l.trim())
                  .filter(Boolean);
                return levels.includes(level.id);
              });
              const isEditing = editingLevel === level.id;

              return (
                <div
                  key={level.id}
                  className="card mb-3"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                  }}
                >
                  <div className="d-flex align-items-center p-3 gap-3">
                    {/* Level label */}
                    <div style={{ minWidth: 180, flexShrink: 0 }}>
                      <span
                        className="fw-semibold"
                        style={{ fontSize: "13px", color: "#330148" }}
                      >
                        {level.label}
                      </span>
                      <div style={{ fontSize: "11px", color: "#aaa" }}>
                        {levelRows.length} user
                        {levelRows.length !== 1 ? "s" : ""}
                      </div>
                    </div>

                    {/* Toggle between pill display and Select */}
                    <div style={{ flex: 1 }}>
                      {isEditing ? (
                        <Select
                          isMulti
                          placeholder="Assign users..."
                          options={allUsers.map((u) => ({
                            value: String(u.id),
                            label: u.name,
                          }))}
                          value={
                            pendingSelections[level.id] ??
                            levelRows.map((r) => ({
                              value: String(r.user_id),
                              label: getUserName(r.user_id),
                            }))
                          }
                          onChange={(selected) =>
                            setPendingSelections((prev) => ({
                              ...prev,
                              [level.id]: selected || [],
                            }))
                          }
                          classNamePrefix="select"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      ) : (
                        <div
                          className="d-flex align-items-center flex-wrap gap-2"
                          style={{
                            minHeight: 38,
                            background: "#fafafa",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                            padding: "6px 10px",
                          }}
                        >
                          {levelRows.length === 0 ? (
                            <span style={{ color: "#ccc", fontSize: "12px" }}>
                              No users assigned
                            </span>
                          ) : (
                            levelRows.map((row) => (
                              <div
                                key={row.user_id}
                                className="d-flex align-items-center gap-1"
                                style={{
                                  background: "#fff",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "20px",
                                  padding: "2px 8px 2px 3px",
                                }}
                              >
                                {/* <div style={{
                  width: 20, height: 20, borderRadius: "50%",
                  background: "#752a97", color: "#fff",
                  fontSize: "9px", fontWeight: 700,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  {getUserName(row.user_id)?.[0]?.toUpperCase()}
                </div> */}
                                {(() => {
                                  const u = allUsers?.find(
                                    (u) => String(u.id) === String(row.user_id),
                                  );
                                  return u?.avatar ? (
                                    <img
                                      src={`${configure.apiUrl}${u.avatar}`}
                                      alt={u.name}
                                      style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        flexShrink: 0,
                                      }}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        background: "#752a97",
                                        color: "#fff",
                                        fontSize: "9px",
                                        fontWeight: 700,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                      }}
                                    >
                                      {getUserName(
                                        row.user_id,
                                      )?.[0]?.toUpperCase()}
                                    </div>
                                  );
                                })()}
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#333",
                                    fontWeight: 500,
                                  }}
                                >
                                  {getUserName(row.user_id)}
                                </span>
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    {/* Buttons */}
                    <div className="d-flex gap-2" style={{ flexShrink: 0 }}>
                      {isEditing && (
                        <button
                          className="btn btn-save btn-sm btn-label"
                        
                          // onClick={async () => {
                          //   const selected = pendingSelections[level.id];
                          //   if (selected !== undefined) {
                          //     setLoading(true); // show loader while saving
                          //     try {
                          //       await onLevelChange(
                          //         level.id,
                          //         selected.map((s) => ({
                          //           ...s,
                          //           value: Number(s.value),
                          //         })),
                          //       );
                          //     } finally {
                          //       setLoading(false);
                          //     }
                          //     setPendingSelections((prev) => {
                          //       const n = { ...prev };
                          //       delete n[level.id];
                          //       return n;
                          //     });
                          //   }
                          //   setEditingLevel(null);
                          // }}


                          onClick={async () => {
  const selected = pendingSelections[level.id];
  if (selected !== undefined) {
    const currentForLevel = data.filter((r) => {
      const levels = (r.level || "").split(",").map((l) => l.trim()).filter(Boolean);
      return levels.includes(level.id);
    });
    const currentIds = new Set(currentForLevel.map((r) => Number(r.user_id)));
    const newIds = new Set(selected.map((s) => Number(s.value)));

    const added = selected.filter((s) => !currentIds.has(Number(s.value)));
    const removed = currentForLevel.filter((r) => !newIds.has(Number(r.user_id)));

    // Build confirmation message
    const lines = [];
    if (added.length) lines.push(`Add: ${added.map((s) => s.label).join(", ")}`);
    if (removed.length) lines.push(`Remove: ${removed.map((r) => getUserName(r.user_id)).join(", ")}`);

    if (lines.length === 0) {
      setEditingLevel(null);
      return;
    }

    const result = await Swal.fire({
      title: `Update ${level.label}?`,
      html: lines.join("<br/>"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, save",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#752a97",
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    try {
      await onLevelChange(
        level.id,
        selected.map((s) => ({ ...s, value: Number(s.value) })),
      );
      Swal.fire({
        icon: "success",
        text: `${level.label} updated successfully!`,
        timer: 1500,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
    setPendingSelections((prev) => {
      const n = { ...prev };
      delete n[level.id];
      return n;
    });
  }
  setEditingLevel(null);
}}
                        >
                          <i className="fas fa-save me-1 label-icon"></i>Save
                        </button>
                      )}
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ fontSize: "12px" }}
                        // onClick={() => setEditingLevel(isEditing ? null : level.id)}
                        onClick={() => {
                          setPendingSelections((prev) => {
                            const n = { ...prev };
                            delete n[level.id];
                            return n;
                          });
                          setEditingLevel(isEditing ? null : level.id);
                        }}
                      >
                        {isEditing ? (
                          <>
                            <i className="dripicons-cross me-1 icon-center"></i>
                            Cancel
                          </>
                        ) : (
                          <>
                            <i className="fas fa-pencil-alt me-1"></i>Edit
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Main page
// ─────────────────────────────────────────────────────────────────────────────

const RfpPermissions = () => {
  document.title = "RFP Permissions | Zithas Technologies";

  const [isLoading, setLoading] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isAddMode, setIsAddMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editPerms, setEditPerms] = useState(null);

  // ── Fetch users ──────────────────────────────────────────────
  useEffect(() => {
    axios
      .get(`${configure.nodeApi}/staff`, {
        headers: { Accept: "application/json" },
      })
      .then((res) => {
        if (res.data.success) setAllUsers(res.data.data || []);
      })
      .catch(console.error);
  }, []);

  // ── Fetch permissions ────────────────────────────────────────
  const fetchAll = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${configure.nodeApi}/rfp_permissions_all`, {
        headers: { Accept: "application/json" },
      });
      if (res.data.success) setRows(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  // ── Helpers ──────────────────────────────────────────────────
  const getUserName = (userId) => {
    const u = allUsers.find((u) => u.id == userId);
    return u ? u.name : `User #${userId}`;
  };

  const usersWithPerms = new Set(rows.map((r) => Number(r.user_id)));
  const unassignedOptions = allUsers
    .filter((u) => !usersWithPerms.has(u.id))
    .map((u) => ({ value: u.id, label: u.name }));

  // ── Toggle ───────────────────────────────────────────────────
  const togglePerm = (stepKey, col) =>
    setEditPerms((prev) => ({
      ...prev,
      [stepKey]: { ...prev[stepKey], [col]: prev[stepKey][col] === 1 ? 0 : 1 },
    }));

  const setAllForStep = (stepKey, value) => {
    const step = STEPS.find((s) => s.key === stepKey);
    const updated = {};
    step.cols.forEach((col) => {
      updated[col] = value;
    });
    setEditPerms((prev) => ({ ...prev, [stepKey]: updated }));
  };

  const isAllSet = (stepKey) => {
    const step = STEPS.find((s) => s.key === stepKey);
    return step.cols.every((col) => editPerms?.[stepKey]?.[col] === 1);
  };

  // ── Open modals ──────────────────────────────────────────────
  // const openAdd = () => {
  //   setIsAddMode(true);
  //   setSelectedUser(null);
  //   setEditPerms(JSON.parse(JSON.stringify(EMPTY_PERMS)));
  //   setModalOpen(true);
  // };

  const openEdit = (userId) => {
    const existing = rows.find((r) => r.user_id == userId);
    setIsAddMode(false);
    setSelectedUser(userId);
    setEditPerms(
      existing
        ? JSON.parse(JSON.stringify(existing.parsed))
        : JSON.parse(JSON.stringify(EMPTY_PERMS)),
    );
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedUser(null);
    setEditPerms(null);
  };

  // ── Save ─────────────────────────────────────────────────────
  const handleSave = async () => {
    const userId = isAddMode ? selectedUser?.value : selectedUser;
    if (!userId)
      return Swal.fire({ icon: "warning", text: "Please select a user" });
    setLoading(true);
    try {
      const res = await axios.post(
        `${configure.nodeApi}/save_rfp_permissions`,
        { user_id: userId, ...permsToStrings(editPerms) },
        { headers: { "Content-Type": "application/json" } },
      );
      if (res.data.success) {
        await fetchAll();
        closeModal();
        Swal.fire({
          icon: "success",
          text: "Permissions saved!",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({ icon: "error", text: res.data.message });
      }
    } catch {
      Swal.fire({ icon: "error", text: "Failed to save permissions" });
    } finally {
      setLoading(false);
    }
  };

  // ── Delete ───────────────────────────────────────────────────
  const handleDelete = (userId) => {
    Swal.fire({
      title: "Remove RFP permissions?",
      text: `All RFP permissions for ${getUserName(userId)} will be removed.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove",
      confirmButtonColor: "#d33",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoading(true);
      try {
        await axios.post(
          `${configure.nodeApi}/save_rfp_permissions`,
          {
            user_id: userId,
            step1: "0,0,0,0",
            step2: "0,0,0,0",
            step3: "0,0,0,0",
            step4: "0,0,0,0",
            step5: "0,0",
          },
          { headers: { "Content-Type": "application/json" } },
        );
        await fetchAll();
        Swal.fire({
          icon: "success",
          text: "Permissions removed!",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch {
        Swal.fire({ icon: "error", text: "Failed to remove permissions" });
      } finally {
        setLoading(false);
      }
    });
  };

  // const handleLevelChange = async (levelId, selectedUsers) => {
  //   // Map level to the perms preset for that level
  //   const LEVEL_PERMS = {
  //     timing: {
  //       step1: "1,1,1,1",
  //       step2: "1,1,1,1",
  //       step3: "1,1,1,0",
  //       step4: "1,1,0,0",
  //       step5: "1,0",
  //     },
  //     costing: {
  //       step1: "1,1,1,0",
  //       step2: "1,1,1,0",
  //       step3: "1,1,1,1",
  //       step4: "1,1,1,0",
  //       step5: "1,0",
  //     },
  //     final: {
  //       step1: "1,1,1,0",
  //       step2: "1,1,1,0",
  //       step3: "1,1,1,1",
  //       step4: "1,1,1,1",
  //       step5: "1,1",
  //     },
  //   };

  //   const currentForLevel = rows.filter((r) => r.level === levelId);
  //   const newIds = new Set(selectedUsers.map((u) => Number(u.value)));
  //   const oldIds = new Set(currentForLevel.map((r) => Number(r.user_id)));

  //   // for (const u of selectedUsers) {
  //   //   if (!oldIds.has(Number(u.value))) {
  //   //     await axios.post(
  //   //       `${configure.nodeApi}/save_rfp_permissions`,
  //   //       { user_id: u.value, level: levelId, ...LEVEL_PERMS[levelId] },
  //   //       { headers: { "Content-Type": "application/json" } },
  //   //     );
  //   //   }
  //   // }
  //   // // Remove deselected users
  //   // for (const r of currentForLevel) {
  //   //   if (!newIds.has(Number(r.user_id))) {
  //   //     await axios.post(
  //   //       `${configure.nodeApi}/save_rfp_permissions`,
  //   //       {
  //   //         user_id: r.user_id,
  //   //         step1: "0,0,0,0",
  //   //         step2: "0,0,0,0",
  //   //         step3: "0,0,0,0",
  //   //         step4: "0,0,0,0",
  //   //         step5: "0,0",
  //   //       },
  //   //       { headers: { "Content-Type": "application/json" } },
  //   //     );
  //   //   }
  //   // }

  //   await Promise.all([
  //     ...selectedUsers
  //       .filter((u) => !oldIds.has(Number(u.value)))
  //       .map((u) =>
  //         axios.post(
  //           `${configure.nodeApi}/save_rfp_permissions`,
  //           { user_id: u.value, level: levelId, ...LEVEL_PERMS[levelId] },
  //           { headers: { "Content-Type": "application/json" } },
  //         ),
  //       ),
  //     ...currentForLevel
  //       .filter((r) => !newIds.has(Number(r.user_id)))
  //       .map((r) =>
  //         axios.post(
  //           `${configure.nodeApi}/save_rfp_permissions`,
  //           {
  //             user_id: r.user_id,
  //             level: null,
  //             step1: "1,1,1,0",
  //             step2: "1,1,1,0",
  //             step3: "1,1,0,0",
  //             step4: "1,1,0,0",
  //             step5: "1,0",
  //           },
  //           { headers: { "Content-Type": "application/json" } },
  //         ),
  //       ),
  //   ]);

  //   await fetchAll();
  // };

  // Helper — merges perms for multiple levels, taking highest value per bit
  const mergePermsForLevels = (levels, LEVEL_PERMS) => {
    const parse = (str, len) => (str || "0".repeat(len)).split(",").map(Number);

    const merged = {
      step1: [0, 0, 0, 0],
      step2: [0, 0, 0, 0],
      step3: [0, 0, 0, 0],
      step4: [0, 0, 0, 0],
      step5: [0, 0],
    };

    for (const level of levels) {
      const p = LEVEL_PERMS[level];
      if (!p) continue;
      merged.step1 = merged.step1.map((v, i) =>
        Math.max(v, parse(p.step1, 4)[i]),
      );
      merged.step2 = merged.step2.map((v, i) =>
        Math.max(v, parse(p.step2, 4)[i]),
      );
      merged.step3 = merged.step3.map((v, i) =>
        Math.max(v, parse(p.step3, 4)[i]),
      );
      merged.step4 = merged.step4.map((v, i) =>
        Math.max(v, parse(p.step4, 4)[i]),
      );
      merged.step5 = merged.step5.map((v, i) =>
        Math.max(v, parse(p.step5, 2)[i]),
      );
    }

    return {
      step1: merged.step1.join(","),
      step2: merged.step2.join(","),
      step3: merged.step3.join(","),
      step4: merged.step4.join(","),
      step5: merged.step5.join(","),
    };
  };

  const handleLevelChange = async (levelId, selectedUsers) => {
    const LEVEL_PERMS = {
      timing: {
        step1: "1,1,1,1",
        step2: "1,1,1,1",
        step3: "1,1,1,0",
        step4: "1,1,0,0",
        step5: "1,0",
      },
      costing: {
        step1: "1,1,1,0",
        step2: "1,1,1,0",
        step3: "1,1,1,1",
        step4: "1,1,1,0",
        step5: "1,0",
      },
      final: {
        step1: "1,1,1,0",
        step2: "1,1,1,0",
        step3: "1,1,1,1",
        step4: "1,1,1,1",
        step5: "1,1",
      },
    };

    // Users currently in THIS level
    const currentForLevel = rows.filter((r) => {
      const levels = (r.level || "")
        .split(",")
        .map((l) => l.trim())
        .filter(Boolean);
      return levels.includes(levelId);
    });

    const newIds = new Set(selectedUsers.map((u) => Number(u.value)));
    const oldIds = new Set(currentForLevel.map((r) => Number(r.user_id)));

    // Users being ADDED to this level
    const toAdd = selectedUsers.filter((u) => !oldIds.has(Number(u.value)));

    // Users being REMOVED from this level
    const toRemove = currentForLevel.filter(
      (r) => !newIds.has(Number(r.user_id)),
    );

    await Promise.all([
      // ── ADD: merge this new level into their existing levels ──
      ...toAdd.map((u) => {
        const existing = rows.find(
          (r) => Number(r.user_id) === Number(u.value),
        );
        const existingLevels = (existing?.level || "")
          .split(",")
          .map((l) => l.trim())
          .filter(Boolean);

        // Add this level if not already there
        if (!existingLevels.includes(levelId)) existingLevels.push(levelId);

        const newLevel = existingLevels.join(",");
        const newPerms = mergePermsForLevels(existingLevels, LEVEL_PERMS);

        return axios.post(
          `${configure.nodeApi}/save_rfp_permissions`,
          { user_id: u.value, level: newLevel, ...newPerms },
          { headers: { "Content-Type": "application/json" } },
        );
      }),

      // ── REMOVE: strip this level, keep remaining levels ──
      ...toRemove.map((r) => {
        const remainingLevels = (r.level || "")
          .split(",")
          .map((l) => l.trim())
          .filter(Boolean)
          .filter((l) => l !== levelId); // remove only this level

        const newLevel = remainingLevels.join(",") || null;
        const newPerms =
          remainingLevels.length > 0
            ? mergePermsForLevels(remainingLevels, LEVEL_PERMS)
            : {
                step1: "1,1,1,0",
                step2: "1,1,1,0",
                step3: "1,1,0,0",
                step4: "1,1,0,0",
                step5: "1,0",
              };

        return axios.post(
          `${configure.nodeApi}/save_rfp_permissions`,
          { user_id: r.user_id, level: newLevel, ...newPerms },
          { headers: { "Content-Type": "application/json" } },
        );
      }),
    ]);

    await fetchAll();
  };

  // ── Columns (memoized) ───────────────────────────────────────
  const columns = useMemo(
    () => RfpPermissionsColumns(openEdit, handleDelete, getUserName),
    [rows, allUsers],
  );

  console.log("unassignedOptions", unassignedOptions);
  // ─────────────────────────────────────────────────────────────

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="RFP Permissions" />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={rows}
                      // onAdd={openAdd}
                      setLoading={setLoading}
                      getUserName={getUserName}
                      onLevelChange={handleLevelChange}
                      allUsers={allUsers}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ── Add / Edit Modal ── */}
      <Modal isOpen={modalOpen} toggle={closeModal} centered size="lg">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {isAddMode
              ? "Add RFP Permissions"
              : `Edit — ${getUserName(selectedUser)}`}
          </h5>
          <button
            type="button"
            onClick={closeModal}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          {/* User dropdown — Add mode only */}
          {isAddMode && (
            <div className="mb-4 col-md-4">
              <label className="form-label fw-semibold">
                Select User <span className="text-danger">*</span>
              </label>
              <Select
                placeholder="select user"
                options={unassignedOptions}
                value={selectedUser}
                onChange={(opt) => setSelectedUser(opt)}
                classNamePrefix="select"
                noOptionsMessage={() => "All users already configured"}
              />
            </div>
          )}

          {editPerms && (
            <>
              {/* Quick presets */}
              <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                <span
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Quick set:
                </span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => {
                    const full = JSON.parse(JSON.stringify(EMPTY_PERMS));
                    STEPS.forEach((s) =>
                      s.cols.forEach((c) => {
                        full[s.key][c] = 1;
                      }),
                    );
                    setEditPerms(full);
                  }}
                >
                  ✓ Full Access
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() =>
                    setEditPerms(JSON.parse(JSON.stringify(EMPTY_PERMS)))
                  }
                >
                  ✕ No Access
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => {
                    const v = JSON.parse(JSON.stringify(EMPTY_PERMS));
                    STEPS.forEach((s) => {
                      v[s.key].view = 1;
                    });
                    setEditPerms(v);
                  }}
                >
                  👁 View Only
                </button>
              </div>

              {/* Permissions table */}
              <div className="table-responsive">
                <Table
                  className="table table-bordered mb-0"
                  style={{ fontSize: "13px" }}
                >
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "160px" }}>Step</th>
                      <th className="text-center">View</th>
                      <th className="text-center">Edit</th>
                      <th className="text-center">Add</th>
                      <th className="text-center">Approve</th>
                      <th className="text-center" style={{ width: "70px" }}>
                        All
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {STEPS.map((step) => (
                      <tr key={step.key}>
                        <td className="fw-semibold align-middle">
                          {step.label}
                        </td>
                        {["view", "edit", "add", "approve"].map((col) => {
                          const applicable = step.cols.includes(col);
                          const checked = applicable
                            ? editPerms[step.key]?.[col] === 1
                            : false;
                          return (
                            <td key={col} className="text-center align-middle">
                              {applicable ? (
                                <div className="form-switch form-switch-md d-flex justify-content-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={checked}
                                    onChange={() => togglePerm(step.key, col)}
                                    style={{ cursor: "pointer" }}
                                  />
                                </div>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                          );
                        })}
                        <td className="text-center align-middle">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              isAllSet(step.key)
                                ? "btn-outline-danger"
                                : "btn-outline-secondary"
                            }`}
                            style={{ fontSize: "11px", padding: "2px 8px" }}
                            onClick={() =>
                              setAllForStep(
                                step.key,
                                isAllSet(step.key) ? 0 : 1,
                              )
                            }
                          >
                            {isAllSet(step.key) ? "Clear" : "All"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-save btn-label" onClick={handleSave}>
            <i className="fas fa-save me-2 label-icon"></i>
            Save
          </button>
          <button className="btn btn-red btn-label ms-2" onClick={closeModal}>
            <i className="dripicons-cross me-2 icon-center label-icon"></i>
            Cancel
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default RfpPermissions;
